<template>
  <div class="btn-auth-tips-content" v-if="!isLogin">
    <div class="btn-auth-tips" @click="btnClick">认证享批发价</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLogin: this.$.user.userLogin(),
    };
  },
  methods: {
    btnClick() {
      if (!this.isLogin) {
        this.$message.warning("请先登录");
        this.$.router.replace("/login");
        return;
      }
    },
  },
};
</script>

<style scoped>
.btn-auth-tips-content {
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn-auth-tips {
  background-color: transparent;
  border: 1px solid #e50012;
  color: #e50012;
  padding: 2px 12px;
  border-radius: 12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BtnAuth/index.vue